/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lonely-if */
/* eslint-disable import/no-cycle */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userAppSiteSelector, companyPrimaryIdSelector } from '../../scenes/Account/AccountSelectors';
import { getToken, clearAllTokens, TOKEN_KEYS } from '../../utils/tokenStorage';

const IPROFILE_SITE = process.env.REACT_APP_IPROFILE_DOMAIN;
const DEFAULT_SITE = process.env.REACT_APP_DOMAIN;
const LMI_COMPANY_ID = 5693;

export const appSite = {
  default: 'lmiriskcoach',
  iprofile: 'iprofilerisk',
};

export const useSiteRedirect = () => {
  const userSite = useSelector(userAppSiteSelector);
  const userPrimaryCompanyId = useSelector(companyPrimaryIdSelector);
  const token = getToken(TOKEN_KEYS.AUTH_TOKEN);

  const redirectUrlGenerator = (domain) => {
    return `https://${domain}${window.location.pathname}?token=${token}`;
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (userSite === appSite.iprofile && !window.location.host.includes(appSite.iprofile)) {
        window.location.replace(redirectUrlGenerator(IPROFILE_SITE));
      }
    } else {
      // Exclude user re-direction to iprofile or riskcoach for LMI Users
      if (userPrimaryCompanyId && userPrimaryCompanyId !== LMI_COMPANY_ID) {
        if (userSite === appSite.iprofile && !window.location.host.toLowerCase().includes(appSite.iprofile)) {
          window.location.replace(redirectUrlGenerator(IPROFILE_SITE));
          clearAllTokens();
        }
        if (userSite === appSite.default && !window.location.host.toLowerCase().includes('riskcoach')) {
          window.location.replace(redirectUrlGenerator(DEFAULT_SITE));
          clearAllTokens();
        }
      }
    }
  }, [userSite, userPrimaryCompanyId]);

  return null;
};
